import { STATUS_MAP } from '@/pages/companies/_company_id/projects/_id/attendance/utils';
import { AttendanceDisplayStatus } from '@/types/attendance';
export function stampStatusToLabel(status) {
    if (status === AttendanceDisplayStatus.MISSING_STAMP) {
        return STATUS_MAP[AttendanceDisplayStatus.MISSING_STAMP].getDisplayValue(0);
    }
    return null;
}
export function formatTimeProject(timeStr) {
    if (!timeStr || typeof timeStr !== 'string')
        return '';
    if (timeStr.match(/^\d{2}:\d{2}:\d{2}$/)) {
        return timeStr.slice(0, 5);
    }
    if (timeStr.match(/^\d{2}:\d{2}$/)) {
        return timeStr;
    }
    return '';
}
